import React from 'react';
import PeaceOfMind from '../PeaceOfMind';
import Styles from './styles.js'

export default function BestUnderStatement({title}) {
  return (
      <>
      
      <div className="pt-10">
          <h2 className="BUS-head-title text-xl lg:text-2xl border-b-2 pb-3 mb-10 uppercase">
                {title}
          </h2>
            <div className="pb-12">
                <PeaceOfMind
                    imgSrc="/static/images/landingPages/RentalMontReal/montreal-img-2.webp"
                    title="Montreal at it's best"
                    para="Properties spread across some of the nicest neighborhoods, the city has to offer, allowing you the time and opportunity to experience the city at its finest."
                    
                    
                />
            </div>
            <div className="pb-12">
                <PeaceOfMind
                    imgSrc="/static/images/landingPages/RentalMontReal/montreal-img-3.webp"
                    title="Conveniently Located"
                    para="Time spent in transit is time wasted. Properties curated for this selection are conveniently located close to public transit stations in addition to being a short walk away from grocery stores, restaurants, etc. "
                    order3="2"
                    order4="1"
                   
                />
            </div>
            <div className="pb-12">
                <PeaceOfMind
                    imgSrc="/static/images/landingPages/RentalMontReal/montreal-img-4.webp"
                    title="Peace of Mind"
                    para="In addition to the lucrative locations, available properties belong to a highly reputable set of landlords and property managers ensuring you have a great experience at any of the places you chose to stay in. "
                    
                    
                />
            </div>
            
      </div>
      {/* <hr/> */}
      <Styles/>
      </>
  );
}
